<template>
  <div class="preview">
    <CourseTest
      v-if="currentStageInfo.type !== 1"
      :test-props="testProps"
      :stage-info="currentStageInfo"
      :preview="true"
      :course-info="courseInfo"
      @reload-test="reloadTest"
    />

    <CourseLesson :course-id="courseInfo.id" v-if="currentStageInfo.type === 1" :current-stage="currentStageInfo" />

    <CourseControls v-if="!testProps.isTestStarted" @backStage="backStage" @nextStage="nextStage" />

    <!-- <CourseDescription :stage-info="currentStageInfo" v-if="!testProps.isTestStarted" /> -->

    <b-loading :is-full-page="false" :active="isLoading"></b-loading>
  </div>
</template>

<script>
import CourseTest from '@/components/user/my-courses/CourseTest'
import CourseLesson from '@/components/user/my-courses/CourseLesson'
import CourseControls from '@/components/user/my-courses/CourseControls'
// import CourseDescription from '@/components/user/my-courses/CourseDescription'

export default {
  components: {
    CourseControls,
    // CourseDescription,
    CourseTest,
    CourseLesson
  },
  props: {
    stagesList: {
      default: () => [],
      type: Array
    },
    courseInfo: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      isLoading: true,
      testProps: {
        isTestStarted: false,
        isEndPage: false,
        isStartPage: true,
        sec: 0,
        ten_sec: 0,
        min: 0,
        ten_min: 0,
        least_sec: 0,
        least_ten_sec: 0
      },
      stageIndex: Number(this.$route.query.stageIndex) || 0,
      currentStageInfo: {
        type: 1,
        text_material: ''
      }
    }
  },
  computed: {
    currentStage() {
      return this.stagesList[this.stageIndex]
    }
  },
  mounted() {
    this.loadStage(this.currentStage.id)
  },
  methods: {
    defaultTestProps() {
      return {
        isTestStarted: false,
        isEndPage: false,
        isStartPage: true,
        sec: 0,
        ten_sec: 0,
        min: 0,
        ten_min: 0,
        least_sec: 0,
        least_ten_sec: 0,
        attempt_number: 0
      }
    },
    nextStage() {
      if (this.stagesList[this.stageIndex + 1]) {
        this.stageIndex += 1
      } else {
        this.stageIndex = 0
      }
      this.$router.replace('?stageIndex=' + this.stageIndex)
      this.loadStage(this.currentStage.id)
    },
    backStage() {
      if (this.stagesList[this.stageIndex - 1]) {
        this.stageIndex -= 1
      } else {
        this.stageIndex = this.stagesList.length - 1
      }
      this.$router.replace('?stageIndex=' + this.stageIndex)
      this.loadStage(this.currentStage.id)
    },
    reloadTest() {
      this.loadStage(this.currentStage.id)
    },
    loadStage(stageId) {
      this.isLoading = true
      this.$axios2
        .get('courses/' + this.currentStage.course_id + '/stages/' + stageId)
        .then((resp) => {
          this.testProps = this.defaultTestProps()
          this.currentStageInfo = resp.data
          this.isLoading = false
        })
        .catch((err) => {
          this.$errorToast(err)
          this.isLoading = false
        })
    }
  }
}
</script>
